import React, { useState, useEffect } from "react";
import { agentApi } from "../../services/agentApi";
import PlaybookVariableHint from "./playbookVariables";

export default function PlaybookIdentityForm({
  playbook,
  agentName = "Marina",
  onSaved,
  readOnly = false,
}) {
  const [form, setForm] = useState({
    name: playbook.name || "",
    persona: playbook.persona || "",
    greeting: playbook.greeting || "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setForm({
      name: playbook.name || "",
      persona: playbook.persona || "",
      greeting: playbook.greeting || "",
    });
  }, [playbook.id]);

  async function handleSave() {
    setSaving(true); setError(null);
    try {
      await agentApi.playbooks.patch(playbook.id, form);
      onSaved && onSaved();
    } catch (err) {
      setError(err.message || "Erro ao salvar");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="space-y-4 max-w-3xl">
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-md text-sm">
          {error}
        </div>
      )}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Nome do agente</label>
        <input
          type="text"
          value={agentName}
          readOnly
          className="w-full px-3 py-2 bg-gray-50 border border-gray-300 text-gray-900 rounded-md cursor-default"
        />
        <p className="mt-1 text-xs text-gray-500">
          Definido pela configuração <span className="font-mono">AGENT_DISPLAY_NAME</span>.
          Nos textos, use <span className="font-mono">{`{{agente}}`}</span>.
        </p>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Nome do playbook</label>
        <input
          type="text"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          readOnly={readOnly}
          className={`w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-md focus:outline-none focus:border-blue-500 ${readOnly ? "cursor-default bg-gray-50" : ""}`}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Persona / Tom</label>
        <textarea
          rows={5}
          value={form.persona}
          onChange={(e) => setForm({ ...form, persona: e.target.value })}
          readOnly={readOnly}
          className={`w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-md font-mono text-sm focus:outline-none focus:border-blue-500 ${readOnly ? "cursor-default bg-gray-50" : ""}`}
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Greeting</label>
        <textarea
          rows={4}
          value={form.greeting}
          onChange={(e) => setForm({ ...form, greeting: e.target.value })}
          readOnly={readOnly}
          className={`w-full px-3 py-2 bg-white border border-gray-300 text-gray-900 rounded-md text-sm focus:outline-none focus:border-blue-500 ${readOnly ? "cursor-default bg-gray-50" : ""}`}
        />
        <PlaybookVariableHint className="mt-1" />
      </div>
      {!readOnly && (
      <button
        onClick={handleSave}
        disabled={saving}
        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-md font-medium transition-colors"
      >
        {saving ? "Salvando..." : "Salvar (incrementa versão)"}
      </button>
      )}
    </div>
  );
}
